import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Input · T4L
 * Per Olga DESIGN-SYSTEM §5 + COMPONENT-LIBRARY §3 (Form tokens)
 *
 *   bg-white border border-slate-200 px-3.5 py-2.5 rounded-lg text-sm
 *   placeholder:text-slate-400
 *   focus: border-[#239D9F] ring-2 ring-[#239D9F]/15
 *   disabled: bg-slate-50 cursor-not-allowed text-slate-400
 *
 * label prop · backward-compat (used by some legacy code · 'block text-sm font-medium')
 */

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, id, ...props }, ref) => {
    const inputId =
      id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

    const inputEl = (
      <input
        ref={ref}
        id={inputId}
        className={cn(
          'w-full px-3.5 py-2.5 bg-white border border-slate-200 rounded-lg text-sm',
          'placeholder:text-slate-400',
          'transition-colors duration-180',
          'focus:outline-none focus:border-[#239D9F] focus:ring-2 focus:ring-[#239D9F]/15',
          'disabled:bg-slate-50 disabled:text-slate-400 disabled:cursor-not-allowed',
          className
        )}
        {...props}
      />
    );

    if (label) {
      return (
        <div>
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-slate-700 mb-1.5"
          >
            {label}
          </label>
          {inputEl}
        </div>
      );
    }

    return inputEl;
  }
);

Input.displayName = 'Input';
export { Input };
export default Input;
